var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHighTendency = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x9B\xBE\xE5\xB1\x82_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0.5C8.53708 0.5 11 2.96292 11 6C11 9.03708 8.53708 11.5 5.5 11.5C2.46292 11.5 -2.15315e-07 9.03708 -4.80825e-07 6C-7.46335e-07 2.96292 2.46292 0.500001 5.5 0.5ZM3.67868 6.04625L4.94203 4.7829L4.94203 8.89551C4.94203 9.0554 5.07546 9.18883 5.23535 9.18883L5.76465 9.18883C5.92454 9.18883 6.05797 9.05705 6.05797 8.89551L6.05797 4.7829L7.32128 6.04625C7.43552 6.16045 7.62187 6.16045 7.73612 6.04625L8.11038 5.67199C8.22458 5.55775 8.22324 5.37001 8.11038 5.25715L5.74906 2.89584C5.68224 2.82901 5.58865 2.80177 5.5 2.81412C5.41135 2.80177 5.31772 2.82901 5.2509 2.89584L2.88958 5.25715C2.77672 5.37001 2.77538 5.55775 2.88958 5.67199L3.26384 6.04625C3.37808 6.16045 3.56443 6.16045 3.67868 6.04625Z",
    fill: "#FF4B55"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHighTendency);
export default ForwardRef;